module.exports = __webpack_public_path__ + "static/media/complexPic16.fe9b8601.png";